import React from 'react';
import { PawPrint, MapPin, Filter } from 'lucide-react';
import { Button } from './ui/button';

interface EmptyStateProps {
  type: 'no-parks' | 'no-filters' | 'welcome';
  onAction?: () => void;
  actionLabel?: string;
  title?: string;
  description?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  type,
  onAction,
  actionLabel,
  title,
  description,
}) => {
  const getContent = () => {
    switch (type) {
      case 'no-parks':
        return {
          icon: <MapPin className="h-16 w-16 text-muted-foreground" />,
          title: title || 'No parks found nearby',
          description:
            description || 'Try adjusting your filters or search area',
        };
      case 'no-filters':
        return {
          icon: <Filter className="h-16 w-16 text-muted-foreground" />,
          title: title || 'No filters applied',
          description:
            description || 'Use filters to find the perfect park for your pet',
        };
      case 'welcome':
        return {
          icon: <PawPrint className="h-16 w-16 text-primary" />,
          title: title || 'Welcome to Petso',
          description:
            description || 'Find the perfect pet-friendly parks near you',
        };
      default:
        return {
          icon: <PawPrint className="h-16 w-16 text-muted-foreground" />,
          title: title || 'No content',
          description: description || '',
        };
    }
  };

  const content = getContent();

  return (
    <div className="flex h-full flex-col items-center justify-center px-6 py-12 text-center">
      <div className="mb-4 flex h-24 w-24 items-center justify-center rounded-full bg-secondary">
        {content.icon}
      </div>
      <h3 className="mb-2 text-lg font-semibold">{content.title}</h3>
      <p className="mb-6 max-w-sm text-sm text-muted-foreground">
        {content.description}
      </p>
      {onAction && actionLabel && (
        <Button onClick={onAction}>{actionLabel}</Button>
      )}
    </div>
  );
};
